// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CustomerStoriesVerticalList_cardContainer__4VvRJ","cardBox":"CustomerStoriesVerticalList_cardBox__uHlgC"};